// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"f679fccf","359":"c4f639c8","361":"4cd8d7e7","511":"b438c446"}[chunkId] + ".chunk.js";
};